// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"5e9a5790","511":"33ded644"}[chunkId] + ".chunk.js";
};